/* eslint-disable @typescript-eslint/ban-ts-comment */
//@ts-nocheck
import { call, put, takeLatest } from 'redux-saga/effects';
import { signInFailure, signInSuccess } from '../reducer/userSlice';
import { signIn } from '../api';
import { isWeb } from '../storage';

export function* signInSaga(action: any): Generator<any, void, unknown> {
  const { apiName, data } = action.payload;
  console.log('signInSaga before', apiName, data);
  try {
    const response: any = yield call(signIn, apiName, data);
    console.log('signInSaga response', response);
    if (response.status === '200') {
      const { accountId, customerId, authenticated, userName,productName } =
        response.authenticateResponse;

      // Dispatch success action with accountId and customerId
      if (
        isWeb && (productName == 'Rogers Corporate' || productName == 'RogersCorporate' || productName?.toLowerCase()?.includes('corporate') )
      ) {
        yield put(
          signInFailure({
            statusCode: response?.status,
            error: {
              errCode: 'COORP_401_USER_ERROR',
              msg: 'You are trying to sign into the consumer portal. Click here to sign into the corporate user login.',
              statusCode: 401,
            },
          })
        );
      } else {
      yield put(
        signInSuccess({
          accountId,
          customerId,
          authenticated,
          data,
          userName,
          productName
        })
      );
       }
    } else {
      const { status, detail, errorCode } = response;
      if (status != null && status === '412') {
        yield put(
          signInFailure({
            statusCode: status,
            error: {
              errCode: 'UNKNOWN_ERROR',
              msg: 'An unknown error occurred.',
              statusCode: status,
            },
          })
        );
      } else if (status != null) {
        yield put(
          signInFailure({
            statusCode: status,
            error: {
              errCode: errorCode ? errorCode : 'UNKNOWN_ERROR',
              msg: detail,
              statusCode: status,
            },
          })
        );
      } else {
        const {
          status = '500',
          errorCode = 'ERR_503_SVC_NOT_AVAIL',
          detail = 'Internal Server error.',
        } = response;
        yield put(
          signInFailure({
            statusCode: status,
            error: {
              errCode: errorCode,
              msg: detail,
            },
          })
        );
      }
    }
  } catch (error: any) {
    const {
      data: {
        status = '500',
        errorCode = 'UNKNOWN_ERROR',
        detail = 'An unknown error occurred.',
      },
    } = error;
    yield put(
      signInFailure({
        statusCode: status,
        error: {
          errCode: errorCode,
          msg: detail,
        },
      })
    );
  }
}
